import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

/**
 *
 * @param {{ sx: import('@mui/material').SxProps, disabledLink: boolean, light:  boolean }} props
 * @returns
 */
export default function Logo({ light, disabledLink = false, sx }) {
  const logoName = light ? 'logo_white.png' : 'logo.png';

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }} component="img" src={`/logo/${logoName}`} height="100%" width="100%" />
  );

  if (disabledLink) {
    return logo;
  }

  return <RouterLink to="/"> {logo} </RouterLink>;
}
